import { useState } from "react"
import { toast } from "react-toastify"
import MyModal from "../MyModal"
import {
    activateBot,
    changeVolume,
    connectBot,
    deleteBot,
    disconnectBot,
    extendBot,
    reconnectBot,
    suspendBot,
} from "../../services/botApis"
import EditMusicBotModal from "./EditMusicBotModal"
import SelectRadioModal from "./SelectRadioModal"
import { useSocket } from "../../contexts/SocketContext"

const MusicBotMoreModal = ({ bot, user }) => {
    const [isOpen, setIsOpen] = useState(false)
    const { isConnected, sendMessage } = useSocket()

    let debounceTimeout = null

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <button onClick={toggleModal}>
                <img className="w-5 h-5" src="assets/icons/gear-complex.svg" />
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="800px" height="500px">
                <div className="grid grid-cols-3">
                    <div className="col-span-2 mt-5 mr-5 ml-5   ">
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>نام</a>
                            <a className="float-left text-blue-400">{bot.name}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>سرور</a>
                            <a className="float-left text-blue-400">
                                {bot?.bot_server_port
                                    ? `${bot.bot_server_ip}:${bot.bot_server_port}`
                                    : bot.bot_server_ip}
                            </a>
                        </li>
                        {bot.type == "normal" ? (
                            <li className="py-2 border-t-2 border-slate-700 relative block">
                                <a>درحال پخش</a>
                                <a className="float-left text-blue-400">{bot?.playing}</a>
                            </li>
                        ) : null}

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>مالک</a>
                            <a className="float-left text-blue-400">{bot.bot_owner}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>چنل دیفالت</a>
                            <a className="float-left text-blue-400">{bot.bot_default_channel_name}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>وضعیت چنل کامندر</a>
                            <a className="float-left text-blue-400">
                                {bot.bot_channel_commander_is_on ? "روشن" : "خاموش"}
                            </a>
                        </li>

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ ساخت</a>
                            <a className="float-left text-blue-400">{bot.crtString}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ انقضا</a>
                            <a className="float-left text-blue-400">
                                {bot.expString ? (
                                    bot.expires < 0 ? (
                                        <span class="text-sm font-medium text-red-500">{bot.expString}</span>
                                    ) : (
                                        <span class="text-sm font-medium text-green-500">{bot.expString}</span>
                                    )
                                ) : (
                                    <span class="text-sm font-medium">دائمی</span>
                                )}
                            </a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>پکیج</a>
                            <a className="float-left text-blue-400">{bot.package_name}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>پنل</a>
                            <a className="float-left text-blue-400">{bot.panel_name}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <button
                                onClick={() => {
                                    const value = document.getElementById("value-display")

                                    if (bot.status == "offline" || !isConnected) {
                                        return
                                    }
                                    sendMessage("changeVolume", {
                                        templateName: bot.template_name,
                                        volume: value.textContent,
                                    })
                                }}
                                style={{ backgroundColor: "#3B82F6" }}
                                className="styled-button"
                            >
                                تغییر صدا
                            </button>
                            <div dir="ltr" className="float-left align-middle w-[80%] flex gap-5">
                                <input
                                    dir="ltr"
                                    onChange={(e) => {
                                        const valueDisplay = document.getElementById("value-display")
                                        valueDisplay.textContent = e.target.value

                                        if (debounceTimeout) {
                                            clearTimeout(debounceTimeout)
                                        }

                                        debounceTimeout = setTimeout(() => {
                                            sendMessage("changeVolume", {
                                                templateName: bot.template_name,
                                                volume: e.target.value,
                                            })
                                        }, 5000)
                                    }}
                                    type="range"
                                    id="volume-range"
                                    className="w-[50%] h-2 my-auto bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                                    min="0"
                                    step="10"
                                    max="100"
                                />
                                <div id="value-display" class="text-blue-400 text-xl ">
                                    50
                                </div>
                            </div>
                        </li>
                        <li className="py-2 border-b-2 border-t-2 border-slate-700 relative block">
                            <a>توضیحات</a>
                            <a className="float-left text-blue-400">{bot.information}</a>
                        </li>
                    </div>
                    <div className="col-span-1 flex flex-col ">
                        <EditMusicBotModal bot={bot} user={user} />
                        {bot.type == "normal" ? <SelectRadioModal bot={bot} user={user} /> : null}

                        <button
                            onClick={() => {
                                if (bot.panel_status == "offline") {
                                    toast.error("پنل بات خاموش میباشد")
                                    return
                                }
                                toast.promise(extendBot(bot.id), {
                                    pending: "در حال تمدید بات",
                                    success: "با موفقیت تمدید شد",
                                })
                            }}
                            style={{ backgroundColor: "#22C55E" }}
                            className="flex justify-center gap-2 border text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            <p>تمدید</p>
                        </button>
                        <button
                            onClick={() => {
                                if (bot.state == "suspended") {
                                    toast.error("بات غیرفعال میباشد")
                                    return
                                }
                                if (bot.panel_status == "offline") {
                                    toast.error("پنل بات خاموش میباشد")
                                    return
                                }
                                toast
                                    .promise(connectBot(bot.id), {
                                        pending: "در حال کانکت",
                                        success: "کانکت شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            className="flex justify-center gap-2 border  bg-green-500 text-white rounded-3xl px-3 py-1 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/play.svg" width="20px" height="20px" />
                            کانکت
                        </button>
                        <button
                            onClick={() => {
                                if (bot.panel_status == "offline") {
                                    toast.error("پنل بات خاموش میباشد")
                                    return
                                }
                                toast
                                    .promise(disconnectBot(bot.id), {
                                        pending: "در حال دیسکانت",
                                        success: "دیسکانکت شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            style={{ backgroundColor: "#DC2626" }}
                            className="flex justify-center border gap-2  text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/power-off.svg" width="20px" height="20px" />
                            دیسکانکت
                        </button>

                        <button
                            onClick={() => {
                                if (bot.state == "suspended") {
                                    toast.error("بات غیرفعال میباشد")
                                    return
                                }
                                if (bot.panel_status == "offline") {
                                    toast.error("پنل بات خاموش میباشد")
                                    return
                                }
                                toast
                                    .promise(reconnectBot(bot.id), {
                                        pending: "در حال ریکانکت",
                                        success: "ریکانکت شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            style={{ backgroundColor: "#6366F1" }}
                            className="flex justify-center gap-2 border text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-indigo-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            ریکانکت
                        </button>
                        {bot.state == "suspended" ? (
                            <button
                                onClick={() => {
                                    if (bot.panel_status == "offline") {
                                        toast.error("پنل بات خاموش میباشد")
                                        return
                                    }
                                    toast
                                        .promise(activateBot(bot.id), {
                                            pending: "در حال فعال کردن بات",
                                            success: "فعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center border  bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                    <rect
                                        x="10.5"
                                        style={{ fill: "#f4f4f5", backgroundColor: "white" }}
                                        width="6"
                                        height="30"
                                    />
                                </svg>
                                فعال کردن
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    if (bot.panel_status == "offline") {
                                        toast.error("پنل بات خاموش میباشد")
                                        return
                                    }
                                    toast
                                        .promise(suspendBot(bot.id), {
                                            pending: "در حال غیرفعال کردن بات",
                                            success: "غیرفعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                style={{ backgroundColor: "#F59E0B" }}
                                className="flex justify-center border  bg-yellow-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                </svg>
                                غیرفعال کردن
                            </button>
                        )}
                        <button
                            onClick={() => {
                                toggleModal()
                                if (bot.panel_status == "offline") {
                                    toast.error("پنل بات خاموش میباشد")
                                    return
                                }
                                toast
                                    .promise(deleteBot(bot.id), {
                                        pending: "در حال حذف کردن بات",
                                        success: "حذف شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            style={{ backgroundColor: "#EF4444" }}
                            className="flex justify-center gap-2 border  bg-red-500 text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/trash-can.svg" width="20px" height="20px" />
                            حذف
                        </button>
                    </div>
                </div>
            </MyModal>
        </>
    )
}

export default MusicBotMoreModal
